module.exports = __webpack_public_path__ + "static/media/Enmascarar grupo 25.bcbf5aaa.png";